import { render, staticRenderFns } from "./ReviewStateNotification.vue?vue&type=template&id=27ddef06&scoped=true&lang=html&"
import script from "./ReviewStateNotification.vue?vue&type=script&lang=js&"
export * from "./ReviewStateNotification.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStateNotification.vue?vue&type=style&index=0&id=27ddef06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddef06",
  null
  
)

component.options.__file = "ReviewStateNotification.vue"
export default component.exports